import { rankWith, uiTypeIs } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { MoreInfoTooltipDynamicForms } from "../../../../../elements/Tooltip";
import { FieldProps, WithDynamicFormContext } from "../WithDynamicFormContext";
import "./style.scss";

const urlPattern =
  /((https?):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;

const LabelControl = (props: FieldProps) => {
  const moreInfo = props.uischema?.options?.moreInfo;
  const classes = props.uischema?.options?.classes;
  const isLink = props.uischema?.options?.link;
  const target = props.uischema?.options?.link?.target;

  return (
    <div className={`label-schema ${classes}`}>
      {props.label.split(" ").map((word) => (
        <>
          {isLink && word.match(urlPattern) && (
            <a href={word} target={target} rel="noreferrer">{`${word} `}</a>
          )}
          {(!word.match(urlPattern) || !isLink) && `${word} `}
        </>
      ))}
      {moreInfo && <MoreInfoTooltipDynamicForms moreInfo={moreInfo} />}
    </div>
  );
};

export const LabelControlEntry = {
  tester: rankWith(1, uiTypeIs("LabelControl")),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(LabelControl)),
};
